import { mapState } from "vuex";

export default {
    computed: {
        ...mapState('user', [
            'teamId',
            'token'
        ])
    },
    methods: {
        set_start_voice({ to }) {
            this.b$.send(
                "rms", { cmd: "set_start_voice", data: { ver: "v1", to } },
                res => {
                    this.l$(res, "startVoice");
                }
            );
        },
        set_stop_voice({ to }) {
            this.b$.send(
                "rms", { cmd: "set_stop_voice", data: { ver: "v1", to } },
                res => {
                    this.l$(res, "stopVoice")
                }
            )
        },
        set_stop_receive ({ to }) {
            this.b$.send(
                "rms", { cmd: "set_stop_receive", data: { ver: "v1", to } },
                res => {
                    this.l$(res, "set_stop_receive");
                }
            );
        },
        set_start_receive ({ to }) {
            this.b$.send(
                "rms", { cmd: "set_start_receive", data: { ver: "v1", to } },
                res => {
                    this.l$(res, "set_start_receive")
                }
            )
        },
        async apiCallAddDevices(devices) {
            this.l$(devices)
            
            return await this.b$.rms.api
                .addDevices({
                    headers: { Authorization: "Bearer " + this.token, customerid: this.teamId },
                    body: { sessionToken: this.token, ...devices, }
                })
                .then(result => {
                    this.l$(result, "apiCallAddDevices")
                    if (result && result.body && result.body.status.code === 0)
                    return Promise.resolve(result)
                })
                .catch(err => Promise.reject(err))
        },
        async apiCallCurrentDevices() {
            return await this.b$.rms.api
                .getCurrentDevices({
                    headers: { Authorization: "Bearer " + this.token, customerid: this.teamId },
                    query: { sessionToken: this.token }
                })
                .then(result => {
                    if (result && result.body && result.body.status.code === 0)
                        return Promise.resolve(result);
                })
                .catch(err => Promise.reject(err));
        },
        async apiCallAllDevices() {
            return await this.b$.rms.api
                .getAllDevices({
                    headers: { Authorization: "Bearer " + this.token, customerid: this.teamId },
                    query: { sessionToken: this.token }
                })
                .then(result => {
                    if (result && result.body && result.body.status.code === 0) {
                        const data = result.body.data.payload;
                        return Promise.resolve(data);
                    }
                })
                .catch(err => Promise.reject(err));
        },
    }
}